import React from 'react';
import { Smartphone, Mail, MapPin, Search, Zap, Shield, MessageCircle, Star, Layout, CheckCircle } from 'lucide-react';
import { mockData } from '../../mock';

const iconMap = {
  'smartphone': Smartphone,
  'mail': Mail,
  'map-pin': MapPin,
  'search': Search,
  'zap': Zap,
  'shield': Shield,
  'message-circle': MessageCircle,
  'star': Star,
  'layout': Layout,
  'check-circle': CheckCircle
};

const WhatsIncludedSection = () => {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#0a0a0a] to-[#111111]">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">What's Included</h2>
          <p className="text-[#9AA3B2] text-lg max-w-2xl mx-auto">
            Everything you need for a professional online presence
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {mockData.whatsIncluded.map((feature) => {
            const Icon = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="flex flex-col items-center text-center p-6 rounded-xl bg-[#1a1a1a]/50 border border-[#2F6BFF]/10 hover:border-[#2F6BFF]/30 transition-all duration-300 group"
              >
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#2F6BFF]/20 to-[#4DA3FF]/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="h-6 w-6 text-[#4DA3FF]" />
                </div>
                <p className="text-[#F5F7FF] text-sm font-medium">{feature.title}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatsIncludedSection;
